var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotiFaved(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNotiFaved") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.4844747,11.962825 C19.7557827,11.699375 19.8515547,11.312725 19.7345307,10.9533 C19.6172307,10.593875 19.3116987,10.3373 18.9363387,10.28285 L15.5989467,9.799675 C15.4568067,9.77905 15.3339867,9.690225 15.2705067,9.5618 L13.7784507,6.5489 C13.6109187,6.210375 13.2708867,6 12.8919387,6 C12.5132667,6 12.1732347,6.210375 12.0057027,6.5489 L10.5133707,9.562075 C10.4498907,9.6905 10.3267947,9.779325 10.1846547,9.79995 L6.84726272,10.283125 C6.47217872,10.3373 6.16637072,10.59415 6.04907072,10.953575 C5.93204672,11.313 6.02781872,11.69965 6.29912672,11.9631 L8.71385072,14.3083 C8.81679872,14.4084 8.86399472,14.5525 8.83970672,14.6933 L8.27004272,18.00485 C8.21953472,18.29635 8.29626272,18.579875 8.48559872,18.80345 C8.77981472,19.151875 9.29345072,19.258025 9.70413872,19.042975 L12.6888027,17.479325 C12.8135547,17.41415 12.9705987,17.4147 13.0950747,17.479325 L16.0800147,19.042975 C16.2251907,19.11915 16.3800267,19.15765 16.5398307,19.15765 C16.8315627,19.15765 17.1081147,19.0284 17.2982787,18.80345 C17.4878907,18.579875 17.5643427,18.2958 17.5138347,18.00485 L16.9438947,14.6933 C16.9196067,14.552225 16.9668027,14.4084 17.0697507,14.3083 L19.4844747,11.962825 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icNotiFaved"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-6",
    stroke: "#FFFFFF",
    fill: "#2C91D0",
    cx: 13,
    cy: 13,
    r: 12.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotiFaved);
export default __webpack_public_path__ + "static/media/icNotiFaved.6ba0ed79a323ea93542ce2f087c3b19e.svg";
export { ForwardRef as ReactComponent };